import React from 'react';
import { Diagnostico } from './pages/Diagnostico';
export function App() {
  return <Diagnostico data-id="element-0" />;
}